import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d738d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-margin" }, null, -1))
const _hoisted_6 = {
  key: 3,
  class: "history-footer p-px-2 p-py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionHeader = _resolveComponent("TransactionHeader")!
  const _component_TransactionShippingDetail = _resolveComponent("TransactionShippingDetail")!
  const _component_TransactionAddressDetail = _resolveComponent("TransactionAddressDetail")!
  const _component_TransactionPaymentDetail = _resolveComponent("TransactionPaymentDetail")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionHeader, {
        transactionInvoice: _ctx.transaction.invoiceNo,
        statusId: _ctx.transaction.statusId,
        statusName: _ctx.transaction.statusName,
        tittle: 'หมายเลขคำสั่งซื้อ',
        isHistory: true
      }, null, 8, ["transactionInvoice", "statusId", "statusName"])
    ]),
    (_ctx.transaction.trackingNo.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_TransactionShippingDetail, {
            trackingNo: _ctx.transaction.trackingNo,
            grandTotal: _ctx.transaction.grandTotal,
            shippingTypeId: _ctx.transaction.shippingTypeId,
            shippingTypeName: _ctx.transaction.shippingTypeName
          }, null, 8, ["trackingNo", "grandTotal", "shippingTypeId", "shippingTypeName"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.transaction.buyerInfo.shippingAddress.zipcode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TransactionAddressDetail, {
            buyerInfo: _ctx.transaction.buyerInfo,
            isDisplayAddress: false
          }, null, 8, ["buyerInfo"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.transaction.paymentMethodId !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_TransactionPaymentDetail, {
            transactionId: _ctx.transaction.id,
            paymentName: _ctx.transaction.paymentName,
            paymentMethodId: _ctx.transaction.paymentMethodId,
            paymentReference: _ctx.transaction.paymentReference
          }, null, 8, ["transactionId", "paymentName", "paymentMethodId", "paymentReference"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_TransactionCartDetail, { transaction: _ctx.transaction }, null, 8, ["transaction"])
    ]),
    _hoisted_5,
    (_ctx.isDisplayButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "w-100",
            label: _ctx.buttonMessage,
            style: _normalizeStyle({
          'background-color': _ctx.backgroundColor,
          'border-color': _ctx.backgroundColor,
        }),
            onClick: _ctx.goToStatus
          }, null, 8, ["label", "style", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}